import React, { Component } from 'react';
import { Select, Row, Col, Typography, Form, Input, Button, notification, Checkbox, Avatar, Result } from 'antd';
import { MailOutlined, UserOutlined, HomeOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';

import Core from "../../Core";
import styles from './index.scss';

const { Title } = Typography;
const { Option } = Select;

export default class Register extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      formSuccess: false,
      redirectLogin: false,
      showOther: false,
    };
    this.onFinish = this.onFinish.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  onFinish(values) {
    const fail = (extraInfo = '') => {
      const description = `Erro ao efetuar registo. ${extraInfo}`
      console.log(extraInfo);
      notification.error({
        message: 'Registo',
        description: <div dangerouslySetInnerHTML={{ __html: description }}></div>,
        top: 200
      });

      ReactGA.event({
        category: Core.data().config.site_title,
        action: `Register`,
        label: `Unsuccessful`
      });

      this.setState({ loading: false, error: true });
    };
    this.setState({ loading: true });
    Core.apiService(`register`, {
      data: {
        name: values.name,
        mail: values.mail.toLowerCase(),
        metadata: {
          workplace: values.workplace,
          postal_code: values.postal_code,
          profession: this.state.showOther ? values.specialty_other : values.specialty
        }
      },
      onSuccess: (data) => {
        if (data.json && data.json['result'] == true) {
          this.setState({ loading: false, formSuccess: true });
          notification.success({
            message: 'Sucesso',
            description: 'Registo efetuado com sucesso.'
          });
          setTimeout(function () {
            this.setState({ redirectLogin: true });
          }.bind(this), 2000);

          ReactGA.event({
            category: Core.data().config.site_title,
            action: `Register`,
            label: `${data.json.name}`
          });
        } else if (data.json && data.json['result'] == false) {
          if (data.json['already_exist']) {
            fail(`O email já se encontra registado. Por favor, faça <a href="/login">login</a>.`);
          } else {
            fail(data.json['msg']);
          }
        } else {
          console.log("Register data is not a JSON!");
          fail();
        }
      },
      onFail: (data) => {
        this.setState({ loadingTable: true });
        console.log("Register data failed.", data);
        fail();
      }
    });
  };

  onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  }

  onChange(e) {

    if (e === "other") {
      this.setState({ showOther: true });
    } else {
      this.setState({ showOther: false });
    }
  }

  render() {
    const { redirectLogin, loading, formSuccess, showOther } = this.state;

    if (redirectLogin) {
      return <Redirect to="/" />;
    }

    const layout = null;/*{
            labelCol: { xl: { span: 10 }, lg: { span: 12 }, md: { span: 14 }, sm: { span: 16 } },
            wrapperCol: { xl: { span: 10 }, lg: { span: 12 }, md: { span: 14 }, sm: { span: 16 } },
        };*/
    const tailLayout = {
      wrapperCol: {
        xl: { span: 10, offset: 7 }, lg: { offset: 6, span: 12 }, md: { span: 14, offset: 5 }, sm: { offset: 4, span: 16 }
      },
    };
    return (
      <div className="register">
        {/* <Row>
          <Col xl={{ span: 10, offset: 7 }} lg={{ span: 12, offset: 6 }} md={{ span: 14, offset: 5 }} sm={{ span: 16, offset: 4 }}>
            <div className="content-title">
              <div className="image"></div>
              <hr />
            </div>
          </Col>
        </Row> */}
        <Row>
          <Col xl={{ span: 10, offset: 7 }} lg={{ span: 12, offset: 6 }} md={{ span: 14, offset: 5 }} sm={{ span: 16, offset: 4 }}>
            {(formSuccess ?
              <Result
                status="success"
                title="Obrigado pelo seu registo. Irá receber um e-mail de confirmação"
                subTitle="Brevemente será redirecionado para a homepage."
              />
              :
              <Form
                {...layout}
                name="basic"
                initialValues={{ remember: true }}
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
              >
                <Form.Item
                  className="center-input"
                  name="name"
                  rules={[{ required: true, message: 'Insira o seu Nome.' }]}
                >
                  <Input prefix={<UserOutlined />} placeholder="Nome" />
                </Form.Item>
                <Form.Item
                  className="center-input"
                  name="mail"
                  rules={[{ required: true, message: 'Insira um Email válido.', pattern: new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,8}$") }]}
                >
                  <Input prefix={<MailOutlined />} placeholder="E-mail" />
                </Form.Item>
                <Form.Item
                  className="center-input"
                  name="postal_code"
                  rules={[{ required: true, message: 'Insira o seu Código Postal.' }]}
                >
                  <Input prefix={<HomeOutlined />} placeholder="Código-postal" />
                </Form.Item>
                <Form.Item
                  className="center-input"
                  name="workplace"
                  rules={[{ required: true, message: 'Insira o seu Local de Trabalho.' }]}
                >
                  <Input prefix={<HomeOutlined />} placeholder="Local de Trabalho" />
                </Form.Item>
                <Form.Item
                  className="center-input"
                  name="specialty"
                  rules={[{ required: true, message: 'Escolha a sua especialidade.' }]}
                >
                  <Select
                    placeholder="Escolha a sua especialidade:"
                    onChange={this.onChange}
                  >
                    <Option value="paediatrician">Pediatra</Option>
                    <Option value="nurse">Enfermeiro</Option>
                    <Option value="pharmacist">Farmacêutico</Option>
                    <Option value="pharmacy_technician">Técnico de Farmácia</Option>
                    <Option value="other">Outra</Option>
                  </Select>
                </Form.Item>
                {showOther && <Form.Item
                  className="center-input"
                  name="specialty_other"
                  rules={[{ required: true, message: 'Indique a sua especialidade.' }]}
                >
                  <Input prefix={<QuestionCircleOutlined />} placeholder="Outra especialidade" />
                </Form.Item>}
                <Form.Item className="register__checkbox"
                  className="center-input"
                  name="checkbox"
                  valuePropName="checked"
                  rules={[{
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject('É necessário aceitar!'),
                  }]}
                >
                  <Checkbox>
                  <b>Consinto</b><br/> Consinto, de forma esclarecida e informada, no tratamento dos meus dados pessoais, para efeitos exclusivos de participação no evento de lançamento Aptamil Profutura. Para mais informações e esclarecimentos sobre a forma como os seus dados são tratados consulte os termos e condições de utilização deste website, disponíveis em <a href="/termos-e-condicoes">Termos e Condições</a> e a nossa politica de privacidade disponível em <a href="https://www.aptababy.com.pt/privacy-policy">Política de Privacidade</a>.
                      </Checkbox>
                </Form.Item>
                <Form.Item className="register__form-action">
                  <Button className="submit-button" type="primary" htmlType="submit" loading={loading}>
                    Registar
                      </Button>
                </Form.Item>
              </Form>
            )}
          </Col>
        </Row>
        <Row>
          <Col xl={{ span: 10, offset: 7 }} lg={{ span: 12, offset: 6 }} md={{ span: 14, offset: 5 }} sm={{ span: 16, offset: 4 }}>
            <hr />
          </Col>
        </Row>
      </div>
    );
  }
}
